export default "/fonts/roboto-regular-webfont.woff2?4f8cffb964ebb25fe991468b97623b9d";